import { Action } from 'redux';
import { IBackgroundJobInfo } from '../../../ts/resources/BackgroundJobs';
import { ToggleBackgroundJobExtendedInfoDialog } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';


export interface ToggleBackgroundJobExtendedInfoDialogAction extends Action {
    backgroundJob: IBackgroundJobInfo;
}

export function toggleBackgroundJobExtendedInfoDialog(
    backgroundJob: IBackgroundJobInfo
): ToggleBackgroundJobExtendedInfoDialogAction {
    return {
        type: ToggleBackgroundJobExtendedInfoDialog,
        backgroundJob,
    };
}

export const isToggleBackgroundJobExtendedInfoDialog = isActionFactory<ToggleBackgroundJobExtendedInfoDialogAction>(ToggleBackgroundJobExtendedInfoDialog);
